// extracted by mini-css-extract-plugin
export default {"icon":"downloadIcon_icon__2U7ag","disabled":"downloadIcon_disabled__CCWBC","invert":"downloadIcon_invert__eFHsq"};